import Vue from "vue";

export default {
    recuperarFiltro(paramsFiltro, pagina, numElementosPagina, ordenacao) {
        return Vue.axios.post("nomeSocial/filtro", {
            params: {
            },
            pagina,
            numElementosPagina,
            ordenacao
        });

    },

    atulizaNomeSocial(item) {
        return Vue.axios.put("nomeSocial/atualizaNomeSocial/"+item.cpf, {
            nomeSocial: item.nomeSocial}  )
    },
    atulizaStatus(item) {
        return Vue.axios.put("nomeSocial/atualizaStatus/"+item.cpf, {
            nomeSocialAprovado: item.nomeSocialAprovado}  )
    }
};


